module.exports = __webpack_public_path__ + "static/media/5.7a7c708c.JPG";